module.exports = __webpack_public_path__ + "b03e97b0313b0ced7d51b4a70e0b1202.png";